import { render, staticRenderFns } from "./FavoriteGames.vue?vue&type=template&id=113c8af9"
import script from "./FavoriteGames.vue?vue&type=script&lang=ts"
export * from "./FavoriteGames.vue?vue&type=script&lang=ts"
import style0 from "./FavoriteGames.vue?vue&type=style&index=0&id=113c8af9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports